import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateUsers, updateUserFormObject } from '@store/slice/usersSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { ROLE_SUPER_ADMIN } from '@router/Routes'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import useDeleteButton from '@hook/useDeleteButton'

const ListUsers = () => {
  const { users } = useSelector(state => state.users)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const [t] = useTranslation('common')
  const navigate = useNavigate()
  const deleteButton = useDeleteButton()

  const dataUsers = { nodes: [] }
  if (users) {
    dataUsers.nodes = Object.values(users)
  }

  const removeUser = id => {
    get(`${import.meta.env.VITE_API_URL}/api/users/remove/${id}`, response => {
      const { code } = response
      if (code == 200) {
        const user = users[id]
        const usersList = { ...users }
        delete usersList[id]
        dispatch(updateUsers({ ...usersList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: user.fullName }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  const goToUpdate = user => {
    get(`${import.meta.env.VITE_API_URL}/api/users/${user.id}`, response => {
      const { user } = response
      dispatch(updateUserFormObject(user))
      navigate(ROLE_SUPER_ADMIN['updateUser'])
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/users${mission.isAdminPanel ? '' : `?mission=${mission.id}`}`, response => {
      const { users } = response
      dispatch(updateUsers(users))
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <h2 className='scene-title'>{t('titles.users_list')}</h2>
      {null !== users
        ? <>
          <Div cssClass='actions-zone'>
            <Buttons buttons={{
              icon: 'icon-add',
              cssClass: 'is-info is-small',
              callback: () => navigate(ROLE_SUPER_ADMIN['createUser']),
              text: t('actions.add')
            }}
            />
          </Div>

          <Table data={dataUsers} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.FullName')}</HeaderCell>
                    <HeaderCell>Email</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.fullName}</Cell>
                      <Cell>{item.email}</Cell>
                      <Cell>{item.isActive ? t('table:yes') : t('table:no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          { icon: 'icon-create', cssClass: 'is-info is-small', callback: () => goToUpdate(item) }
                        ]} />
                        {deleteButton(item.id, item.fullName, removeUser)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListUsers